var React = require('react');

function Postcode (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(4 3)","fill":"none","fillRule":"evenodd"},[React.createElement("ellipse",{"stroke":"#9AA4B4","cx":"5.526","cy":"11.421","rx":"5.026","ry":"2.079","key":0}),React.createElement("path",{"d":"M5.334 12.318C3.361 9.948 2.13 8.324 1.63 7.43 1.047 6.39.855 5.54.855 4.53.855 2.09 2.95.117 5.526.117c2.577 0 4.671 1.972 4.671 4.411 0 1.001-.197 1.853-.784 2.901-.5.893-1.728 2.517-3.694 4.887l-.192.232-.193-.231v.001zm.192-6.305a1.224 1.224 0 1 0 .07-2.447 1.224 1.224 0 0 0-.07 2.447z","stroke":"#F2F3F4","strokeWidth":".5","fill":"#9AA4B4","fillRule":"nonzero","key":1})]));
}

Postcode.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = Postcode;

Postcode.default = Postcode;
